import { ApolloClient, ApolloQueryResult } from '@apollo/client'
import gql from 'graphql-tag'
import {
  SafetyNetPackageName,
  ListSafetyNetPackageNamesResult,
} from '../../../../api'

export const QUERY = gql`
  query ListSafetyNetPackageNames($limit: Int, $nextToken: String) {
    listSafetyNetPackageNames(limit: $limit, nextToken: $nextToken) {
      items {
        packageName
      }
      nextToken
    }
  }
`

export const listSafetyNetPackageNames = async (
  client: ApolloClient<unknown>,
): Promise<SafetyNetPackageName[]> => {
  let nextToken
  let items: SafetyNetPackageName[] = []

  do {
    const queryResult: ApolloQueryResult<{
      listSafetyNetPackageNames: ListSafetyNetPackageNamesResult
    }> = await client.query<{
      listSafetyNetPackageNames: ListSafetyNetPackageNamesResult
    }>({
      query: QUERY,
      fetchPolicy: 'no-cache',
      variables: { limit: 100, nextToken },
    })

    nextToken = queryResult.data.listSafetyNetPackageNames.nextToken
    if (queryResult.data.listSafetyNetPackageNames.items) {
      items = items.concat(queryResult.data.listSafetyNetPackageNames.items)
    }
  } while (!!nextToken)

  return items
}
